import { TaskPeriod } from '../index';

interface TaskTabsProps {
  activeTab: TaskPeriod;
  onTabChange: (tab: TaskPeriod) => void;
}

export function TaskTabs({ activeTab, onTabChange }: TaskTabsProps) {
  const tabs: { id: TaskPeriod; label: string }[] = [
    { id: 'daily', label: 'Daily' },
    { id: 'weekly', label: 'Weekly' },
    { id: 'campaign', label: 'Campaign-Long' },
  ];

  return (
    <div className="flex gap-2 mb-4">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
            activeTab === tab.id
              ? 'bg-white text-black'
              : 'bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-white'
          }`}
        >
          {tab.label}
        </button>
      ))}

      {/* Reset timer for daily tasks */}
      {activeTab === 'daily' && (
        <div className="ml-auto flex items-center text-gray-400 text-sm">
          <span>The task will reset after</span>
          <DailyResetTimer />
        </div>
      )}
    </div>
  );
}

function DailyResetTimer() {
  // Calculate time until midnight UTC
  const now = new Date();
  const tomorrow = new Date(Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate() + 1,
    0, 0, 0
  ));
  const diff = tomorrow.getTime() - now.getTime();

  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  return (
    <span className="ml-2 text-white font-mono">
      {String(hours).padStart(2, '0')}:{String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
    </span>
  );
}
